import React from 'react';
import { motion } from 'framer-motion';
export function WorksLoading() {
  return <div className="flex flex-col items-center justify-center py-32" data-id="element-173">
      {/* Animated loading bar */}
      <div className="w-48 h-0.5 bg-white/10 rounded-full overflow-hidden mb-6" data-id="element-174">
        <motion.div className="h-full bg-white rounded-full" initial={{
        x: '-100%'
      }} animate={{
        x: '100%'
      }} transition={{
        duration: 1,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-175" />
      </div>

      {/* Loading text */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.2
    }} className="flex items-center gap-2" data-id="element-176">
        <span className="text-sm uppercase tracking-widest font-light text-white/60" data-id="element-177">
          Loading Works
        </span>
        <motion.span animate={{
        opacity: [0, 1, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'linear'
      }} className="text-sm text-white/60" data-id="element-178">
          ...
        </motion.span>
      </motion.div>

      {/* Optional: Loading dots */}
      <div className="flex items-center justify-center gap-2 mt-6" data-id="element-179">
        {[0, 1, 2].map(i => <motion.div key={i} className="w-1.5 h-1.5 bg-white/40 rounded-full" animate={{
        opacity: [0.3, 1, 0.3],
        scale: [0.8, 1.2, 0.8]
      }} transition={{
        duration: 1,
        repeat: Infinity,
        delay: i * 0.2
      }} data-id="element-180" />)}
      </div>
    </div>;
}